import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import React from "react";
import useRefForContext from "../utils/useRefForContext.js";
const ModalPortalRefContext = /*#__PURE__*/React.createContext();

const ModalPortalProvider = _ref => {
  let {
    children
  } = _ref;
  const ref = useRefForContext();
  return /*#__PURE__*/React.createElement(ModalPortalRefContext.Provider, {
    value: ref
  }, children(ref));
};

process.env.NODE_ENV !== "production" ? ModalPortalProvider.propTypes = {
  children: PropTypes.func
} : void 0;
/**
 * Renders its children inside of the modal container created by `LayoutRoot`
 */

const ModalPortal = _ref2 => {
  let {
    children
  } = _ref2;
  const ref = React.useContext(ModalPortalRefContext); // If layout is not preset, just render modal

  if (!ref) {
    return children;
  } // Layout is present but portal container hasn't mounted yet


  if (!ref.current) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/ReactDOM.createPortal(children, ref.current));
};

ModalPortal.propTypes = {
  children: PropTypes.node
};
export { ModalPortalProvider, ModalPortal };